import { logDispatcher } from 'src/app/core/decorators/state.decorators';
import { InvoicingServiceData } from '../interfaces/invoicingService-data.model';
import {
  InvoicingServicesForm,
} from '../interfaces/invoicingServices-form.model';

export namespace AttendanceServicesActions {
  @logDispatcher
  export class GetAttendanceServices {
    static readonly type = '[AttendanceServices] GetAttendanceServices';
    constructor(
      public year: number,
      public month: number,
      public schoolId: number,
      public exerciseId: number
    ) {}
  }

  @logDispatcher
  export class GetAttendanceServicesSuccess {
    static readonly type = '[AttendanceServices] GetAttendanceServicesSuccess';
    constructor(public invoicingServices: InvoicingServiceData[]) {}
  }

  @logDispatcher
  export class PreEditAttendanceServices {
    static readonly type = '[AttendanceServices] PreEditAttendanceServices';
    constructor(public invoicingServicesForm: InvoicingServicesForm) {}
  }

  @logDispatcher
  export class EditAttendanceServiceRow {
    static readonly type = '[AttendanceServices] EditAttendanceServiceRow';
    constructor(
      public serviceConceptId: number,
      public dayIndex: number,
      public amount: number
    ) {}
  }

  @logDispatcher
  export class SaveAttendancesServices {
    static readonly type = '[AttendanceServices] SaveAttendancesServices';
    constructor(
      public invoicingServicesForm: InvoicingServicesForm,
      public user: string
    ) {}
  }

  @logDispatcher
  export class SaveAttendancesServicesSuccess {
    static readonly type =
      '[AttendanceServices] SaveAttendancesServicesSuccess';
    constructor() {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[AttendanceServices] Error';
    constructor(public error: any) {}
  }

  @logDispatcher
  export class SetIsListSmaller {
    static readonly type = '[AttendanceServices] SetIsListSmaller';
    constructor(public isListSmaller: boolean) {}
  }

  @logDispatcher
  export class SetAttendanceServicesDefaultState {
    static readonly type =
      '[AttendanceServices] SetAttendanceServicesDefaultState';
    constructor() {}
  }
}
